var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"provider",attrs:{"block":""},on:{"click":_vm.handleLogin}},[_c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('Icon',{attrs:{"name":"googleProvider","width":20}}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.$t('forms.login_form.continue_google')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }